import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

import { AuthContextService } from './auth-context.service';
import { Observable } from 'rxjs/Observable';@Injectable()
export class TokenInterceptor implements HttpInterceptor {  constructor(public auth: AuthContextService) {}  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
	if (this.auth.getToken()!==null){
		request = request.clone({
	      setHeaders: {
	        Authorization: `Bearer ${this.auth.getToken()}`
	      }
	    });
	}
    return next.handle(request);
  }
}


// WEBPACK FOOTER //
// ./src/app/token.interceptor.ts